// ==========================================
// 🇮🇳 INDIAN GOVERNMENT EXAMS TYPING DATABASE
// ==========================================

export const INDIAN_EXAMS = [
  // ==========================================
  // 📚 CENTRAL GOVERNMENT / NATIONAL EXAMS
  // ==========================================
  {
    id: "ssc_chsl",
    name: "SSC CHSL (LDC / JSA / PA)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Staff Selection Commission Combined Higher Secondary Level. 10-minute test duration. Evaluation is highly structured with strict calculation for half and full mistakes.",
    scoringRule: "ssc",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "ssc_chsl_eng", label: "English (QWERTY)", lang: "english", speed: 35 },
      { id: "ssc_chsl_gail", label: "Hindi (Remington GAIL)", lang: "remington_gail", speed: 30 },
      { id: "ssc_chsl_ins", label: "Hindi (Mangal InScript)", lang: "inscript", speed: 30 },
      { id: "ssc_chsl_kd", label: "Hindi (Kruti Dev 010)", lang: "kruti_dev", speed: 30 }
    ]
  },
  {
    id: "ssc_cgl_dest",
    name: "SSC CGL (DEST)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Data Entry Speed Test for Central Secretariat, Excise, and Income Tax Inspector posts. Requires a steady speed over a 15-minute testing window.",
    scoringRule: "ssc",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "ssc_cgl_eng", label: "English (QWERTY)", lang: "english", speed: 27 },
      { id: "ssc_cgl_gail", label: "Hindi (Remington GAIL)", lang: "remington_gail", speed: 27 },
      { id: "ssc_cgl_ins", label: "Hindi (Mangal InScript)", lang: "inscript", speed: 27 }
    ]
  },
  {
    id: "ssc_steno_trans",
    name: "SSC Stenographer (Grade C & D)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Skill test transcription module. Simulates the typing evaluation portion of the shorthand dictation transcription.",
    scoringRule: "ssc",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "ssc_steno_eng", label: "English Standard", lang: "english", speed: 40 },
      { id: "ssc_steno_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 },
      { id: "ssc_steno_kd", label: "Hindi Kruti Dev 010", lang: "kruti_dev", speed: 30 }
    ]
  },
  {
    id: "rrb_ntpc_typist",
    name: "RRB NTPC (Clerk / Typist)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Railway Recruitment Board NTPC skill test. Features a custom restricted UI environment where backspace functionality is modified to match national testing standards.",
    scoringRule: "standard",
    defaultBackspace: "disabled_after_space",
    allowedOptions: [
      { id: "rrb_eng", label: "English (QWERTY)", lang: "english", speed: 30 },
      { id: "rrb_gail", label: "Hindi (Remington GAIL)", lang: "remington_gail", speed: 25 },
      { id: "rrb_ins", label: "Hindi (Mangal InScript)", lang: "inscript", speed: 25 },
      { id: "rrb_kd", label: "Hindi (Kruti Dev 010)", lang: "kruti_dev", speed: 25 }
    ]
  },
  {
    id: "epfo_ssa",
    name: "EPFO SSA (Social Security Assistant)",
    type: "standard",
    requiredAccuracy: 95,
    description: "National Testing Agency (NTA) conducted typing sprint. Requires matching a threshold of 10,500 KDPH for English or 9,000 KDPH for Hindi tracks.",
    scoringRule: "ssc",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "epfo_eng", label: "English Medium", lang: "english", speed: 35 },
      { id: "epfo_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 },
      { id: "epfo_ins", label: "Hindi Mangal InScript", lang: "inscript", speed: 30 }
    ]
  },
  {
    id: "kvs_jsa",
    name: "KVS JSA (Junior Secretariat Assistant)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Kendriya Vidyalaya Sangathan ministerial deployment skill assessment. Standard 10-minute automated portal evaluation rules apply.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "kvs_eng", label: "English Section", lang: "english", speed: 35 },
      { id: "kvs_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 },
      { id: "kvs_kd", label: "Hindi Kruti Dev 010", lang: "kruti_dev", speed: 30 }
    ]
  },
  {
    id: "nvs_assistant",
    name: "Navodaya Vidyalaya JSA",
    type: "standard",
    requiredAccuracy: 95,
    description: "NVS clerk cadre competency challenge. Follows central educational board parameters with a 10-minute window.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "nvs_eng", label: "English Medium", lang: "english", speed: 35 },
      { id: "nvs_ins", label: "Hindi Mangal InScript", lang: "inscript", speed: 30 },
      { id: "nvs_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "fci_ag_three",
    name: "FCI Assistant Grade III",
    type: "standard",
    requiredAccuracy: 95,
    description: "Food Corporation of India management and administrative typist evaluation panel. Uses basic net speed parameters.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "fci_eng", label: "English Stream", lang: "english", speed: 30 },
      { id: "fci_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "esic_udc_skill",
    name: "ESIC UDC & Steno",
    type: "standard",
    requiredAccuracy: 95,
    description: "Employees' State Insurance Corporation computer skill test sub-module. Focuses on structured formatting accuracy templates.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "esic_eng", label: "English Layout", lang: "english", speed: 35 },
      { id: "esic_ins", label: "Hindi Mangal InScript", lang: "inscript", speed: 30 }
    ]
  },
  {
    id: "drdo_ceam",
    name: "DRDO CEAM (Admin & Allied)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Defence Research and Development Organisation technical typist program. High baseline accuracy requirements over a 10-minute assessment.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "drdo_eng", label: "English Entry", lang: "english", speed: 35 },
      { id: "drdo_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },

  // ==========================================
  // ⚔️ DEFENSE & PARAMILITARY (CAPF) MINISTERIAL
  // ==========================================
  {
    id: "crpf_hcm",
    name: "CRPF Head Constable (Ministerial)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Widely regarded as India's most punishing defense typing test. The interface completely locks backspace capabilities to simulate absolute battlefield coordination simulation constraints.",
    scoringRule: "standard",
    defaultBackspace: "disabled",
    allowedOptions: [
      { id: "crpf_eng", label: "English (Strict)", lang: "english", speed: 35 },
      { id: "crpf_gail", label: "Hindi (Remington GAIL)", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "cisf_hcm",
    name: "CISF Head Constable (Ministerial)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Central Industrial Security Force clerical wing selection board format. Standard full backspace allowance with fixed threshold limits.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "cisf_eng", label: "English Medium", lang: "english", speed: 35 },
      { id: "cisf_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "bsf_hcm",
    name: "BSF Head Constable (Ministerial)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Border Security Force combatant ministerial review. 10-minute test format calculated using a net speed formula.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "bsf_eng", label: "English Entry", lang: "english", speed: 35 },
      { id: "bsf_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "itbp_hcm",
    name: "ITBP Head Constable (Ministerial)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Indo-Tibetan Border Police deployment sprint. Performed under classic military board software templates with net precision checks.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "itbp_eng", label: "English Layout", lang: "english", speed: 35 },
      { id: "itbp_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "ssb_hcm",
    name: "SSB Head Constable (Ministerial)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Sashastra Seema Bal administrative entry gate. Employs classic speed mechanics requiring dedicated home row anchorage stability.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "ssb_eng", label: "English Stream", lang: "english", speed: 35 },
      { id: "ssb_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },

  // ==========================================
  // 🏛️ STATE PUBLIC SERVICE COMMISSIONS & BOARDS
  // ==========================================
  {
    id: "upsssc_jr_asst",
    name: "UPSSSC Junior Assistant (Uttar Pradesh)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Uttar Pradesh Subordinate Services Selection Commission. Candidates must prepare highly optimized layout paths. Outstanding benchmark state-level administrative portal framework.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "upsssc_eng", label: "English Layout", lang: "english", speed: 30 },
      { id: "upsssc_kd", label: "Hindi (Kruti Dev 010)", lang: "kruti_dev", speed: 25 },
      { id: "upsssc_ins", label: "Hindi (Mangal InScript)", lang: "inscript", speed: 25 }
    ]
  },
  {
    id: "bihar_beltron",
    name: "Bihar Beltron DEO",
    type: "standard",
    requiredAccuracy: 95,
    description: "Bihar State Electronics Development Corporation Data Entry Operator test. Remington GAIL maps beautifully into their local verification servers.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "beltron_eng", label: "English Core", lang: "english", speed: 30 },
      { id: "beltron_gail", label: "Hindi (Remington GAIL)", lang: "remington_gail", speed: 25 },
      { id: "beltron_ins", label: "Hindi (Mangal InScript)", lang: "inscript", speed: 25 }
    ]
  },
  {
    id: "bssc_inter_clerk",
    name: "BSSC Inter Level LDC (Bihar)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Bihar Staff Selection Commission intermediate level typing evaluation segment. Uses classic paragraph blocks.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "bssc_eng", label: "English Section", lang: "english", speed: 30 },
      { id: "bssc_gail", label: "Hindi (Remington GAIL)", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "dsssb_junior_clerk",
    name: "DSSSB LDC / Junior Assistant (Delhi)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Delhi Subordinate Services Selection Board municipal office typing trial. Fast-paced 10-minute computer screen copy setup.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "dsssb_eng", label: "English Standard", lang: "english", speed: 35 },
      { id: "dsssb_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "delhi_police_hc_min",
    name: "Delhi Police HC (Ministerial)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Conducted under strict verification setups. High-speed benchmark thresholds requiring rigorous hand stability across rows.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "dp_eng", label: "English Track", lang: "english", speed: 30 },
      { id: "dp_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 25 }
    ]
  },
  {
    id: "jssc_ckht",
    name: "JSSC CKHT (Jharkhand)",
    type: "standard",
    requiredAccuracy: 98,
    description: "Jharkhand Staff Selection Commission clerk exam. Demands exceptional typing performance under high state-level competitive pressure.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "jssc_eng", label: "English Component", lang: "english", speed: 30 },
      { id: "jssc_kd", label: "Hindi (Kruti Dev 010)", lang: "kruti_dev", speed: 25 }
    ]
  },
  {
    id: "hssc_clerk_sprint",
    name: "HSSC Clerk Exam (Haryana)",
    type: "standard",
    requiredAccuracy: 95,
    description: "Haryana Staff Selection Commission clerical assessment grid. Standard entry rules apply over 10 minutes.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "hssc_eng", label: "English Metric", lang: "english", speed: 30 },
      { id: "hssc_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 25 }
    ]
  },
  {
    id: "cg_vyapam_ag3",
    name: "Chhattisgarh Vyapam Assistant Gr. 3",
    type: "standard",
    requiredAccuracy: 95,
    description: "CG Vyapam data handling and administrative entry metrics. Often measured in total key depressions per hour.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "cg_eng", label: "English 5000 KDPH", lang: "english", speed: 30 },
      { id: "cg_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 25 }
    ]
  },

  // ==========================================
  // ⚖️ HIGH COURTS & JUDICIAL DISTRICT BENCHES
  // ==========================================
  {
    id: "delhi_court_jja",
    name: "Delhi District Courts (JJA)",
    type: "standard",
    requiredAccuracy: 97,
    description: "Junior Judicial Assistant typing program. Exceptionally clean interface requiring high-speed legal transcript handling over 10 minutes.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "ddc_jja_eng", label: "English Judicial Standard", lang: "english", speed: 40 }
    ]
  },
  {
    id: "allahabad_hc_typist",
    name: "Allahabad HC Computer Asst.",
    type: "standard",
    requiredAccuracy: 95,
    description: "Standalone legal technical track for Uttar Pradesh judicial administration offices.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "ahc_ca_eng", label: "English Legal Format", lang: "english", speed: 30 }
    ]
  },
  {
    id: "bihar_civil_court",
    name: "Bihar Civil Court Deposition Writer",
    type: "standard",
    requiredAccuracy: 95,
    description: "Civil court track for clerk and deposition typist selection. Highly valued state legal service deployment exam.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "bihar_court_eng", label: "English Court Track", lang: "english", speed: 40 },
      { id: "bihar_court_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 30 }
    ]
  },
  {
    id: "uttarakhand_hc_clerk",
    name: "Uttarakhand High Court Typist",
    type: "standard",
    requiredAccuracy: 95,
    description: "Nainital High Court administrative selection matrix. Standard testing script rules with 10-minute blocks.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "uk_hc_eng", label: "English Stream", lang: "english", speed: 35 },
      { id: "uk_hc_gail", label: "Hindi Remington GAIL", lang: "remington_gail", speed: 25 }
    ]
  },

  // ==========================================
  // 🏆 SEQUENTIAL BILINGUAL EXAMS (Mandatory Both)
  // ==========================================
  {
    id: "ahc_ro_aro",
    name: "Allahabad High Court RO/ARO",
    type: "sequential",
    requiredAccuracy: 98,
    description: "Strict bilingual evaluation framework. Aspirants must clear the English section, clear the interface, and immediately face the Hindi Mangal layout segment. Backspace usage past word boundaries is restricted.",
    scoringRule: "standard",
    defaultBackspace: "disabled_after_space",
    allowedOptions: [
      { id: "ahc_bilingual", label: "English (30 WPM) ➔ Hindi Mangal InScript (25 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "up_police_asi_clerk",
    name: "UP Police ASI (Clerk / Accounts)",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Bilingual police headquarters technical segment. English must be passed continuously before the script controller opens the Remington GAIL module.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "upp_asi_bilingual", label: "English (30 WPM) ➔ Hindi Remington GAIL (15 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "up_police_computer_op",
    name: "UP Police Computer Operator",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Technical operational deployment track. Highly popular sequential framework requiring 15 minutes of dedication per module.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "upp_co_bilingual", label: "English (30 WPM) ➔ Hindi Mangal InScript (25 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "mp_highcourt_asst",
    name: "MP High Court Assistant Grade III",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Madhya Pradesh High Court backend staff gate. Demands elite focus to execute intense linguistic hand-switching patterns back-to-back.",
    scoringRule: "standard",
    defaultBackspace: "disabled_after_space",
    allowedOptions: [
      { id: "mphc_bilingual", label: "English (40 WPM) ➔ Hindi Remington GAIL (30 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "patna_hc_assistant",
    name: "Patna High Court Assistant",
    type: "sequential",
    requiredAccuracy: 95,
    description: "High-speed bilingual state portal simulation. Legal vocabulary and high accuracy limits define this competitive judicial pipeline.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "patnahc_bilingual", label: "English (40 WPM) ➔ Hindi Mangal InScript (30 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "rsmssb_ldc_exam",
    name: "RSMSSB LDC / Junior Assistant (Rajasthan)",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Rajasthan Subordinate Board high-stakes clerk exam. Scores heavily determine final merit listing. Requires back-to-back language proficiency tests.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "rsmssb_bilingual", label: "English Speed (35 WPM) ➔ Hindi Kruti Dev 010 (30 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "raj_highcourt_ldc",
    name: "Rajasthan High Court LDC",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Judicial staff registry evaluation. Combines raw speed benchmarks with subsequent data formatting accuracy models under localized layouts.",
    scoringRule: "standard",
    defaultBackspace: "disabled_after_space",
    allowedOptions: [
      { id: "rhc_bilingual", label: "English Track (35 WPM) ➔ Hindi Kruti Dev 010 (30 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "mp_cpct_cert",
    name: "MP CPCT Certification Test",
    type: "sequential",
    requiredAccuracy: 90,
    description: "Computer Proficiency Certification Test. The mandatory universal state credential for all clerk and data handler vacancies in Madhya Pradesh.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "cpct_bilingual", label: "English Core (30 WPM) ➔ Hindi Remington/InScript (20 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "uksssc_personal_asst",
    name: "UKSSSC Personal Assistant (Uttarakhand)",
    type: "sequential",
    requiredAccuracy: 95,
    description: "State clerical and secretary support staff tracking system. Demands clean back-to-back testing precision.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "uksssc_bilingual", label: "English Standard (35 WPM) ➔ Hindi Kruti Dev 010 (25 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "central_steno_bilingual",
    name: "Central Stenographer Bilingual Bureau",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Autonomous central institutional frameworks requesting bilingual profile cross-matching steno typists.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "steno_bilingual_seq", label: "English Transcription (35 WPM) ➔ Hindi Remington GAIL (30 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  },
  {
    id: "cbi_remington_special",
    name: "CBI Assistant Clerical Track",
    type: "sequential",
    requiredAccuracy: 95,
    description: "Specialized central investigative bureau data clerk tracks requiring precise Remington CBI layout coordination protocols.",
    scoringRule: "standard",
    defaultBackspace: "free",
    allowedOptions: [
      { id: "cbi_bilingual_seq", label: "English Base (35 WPM) ➔ Hindi Remington CBI (30 WPM)", lang: "sequential", speed: "Combined Track" }
    ]
  }
];